<template>
	<v-container>
		<component :is="getMovimentiComponent" />
	</v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

import Index from './../components/movimenti/Index'
import Insert from './../components/movimenti/Insert'

export default {
	name: 'MagazzinoAccessori',
	components: {
		Index,
		Insert,
	},
	computed: {
		...mapGetters(['getMovimentiComponent']),
	},
	methods: {
		...mapMutations(['CHANGE_MOVIMENTI_COMPONENT']),
	},
	destroyed() {
		this.CHANGE_MOVIMENTI_COMPONENT('Index')
	},
}
</script>
